import { render, staticRenderFns } from "./edpHeader.vue?vue&type=template&id=d84df846&"
import script from "./edpHeader.vue?vue&type=script&lang=js&"
export * from "./edpHeader.vue?vue&type=script&lang=js&"
import style0 from "./edpHeader.vue?vue&type=style&index=0&id=d84df846&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports